import React, {useEffect} from 'react';

import { withStyles, Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Button from "@material-ui/core/Button";

import moment from 'moment'
import { Container, IconButton } from '@material-ui/core';

import GetAppRounded from '@material-ui/icons/GetAppRounded';
import { getFromAPI } from '../helpers/sqlApiCalls';
import { CSVLink } from 'react-csv';

const columns = [
    { id: 'date', label: 'Fecha', maxWidth: 70 },
    { id: 'code', label: 'Comprobante', minWidth: 120 },
    { id: 'dueDate', label: 'Vencimiento', maxWidth: 70 },
    { id: 'cuenta', label: 'C/G', maxWidth: 50 },
    { id: 'overdue', align: 'right', label: 'Atraso', maxWidth: 70 },
    { id: 'amount', label: 'Importe', maxWidth: 70, align: 'right', format: (value: number) => value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'), },
    { id: 'pending', label: 'Saldo', maxWidth: 70, align: 'right', format: (value: number) => value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'), },
    // { id: 'download', align: 'center', label: "Descargar", maxWidth: 70, minWidth: 70 }

]
const useStyles = makeStyles({
    root: {
        minWidth: 275,
        width: "100%"
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
    container: {
        maxHeight: 440,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    }
});
// const useStyles = makeStyles(theme => ({
//     icons: {
//         display: 'flex',
//     },
//     tagsContainer: {
//         '& > div': {
//             border: '1px solid',
//             borderRadius: '4px',
//             height: '70%',
//             minWidth: '128px',
//             minHeight: '30px',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             cursor: 'default',
//             margin: '5px 10px 5px 0px',
//             padding: '0px 5px'
//         },
//         display: 'flex',
//         // flexWrap: 'wrap',
//         width: '398px',

//     },
//     headerFixed: {
//         position: 'relative',
//         zIndex: 9999,
//         background: '#fff',
//         borderRadius: '9px 9px 0px 0px',
//         left: 0,
//     },
//     typography: {
//         padding: theme.spacing(2),
//     },
//     typographyButton: {
//         padding: theme.spacing(1),
//     },
//     headerFilters: {
//         overflowX: 'scroll',
//         overflowY: 'hidden',
//         marginTop: '0.5rem'
//     },
//     tableCell: {
//         padding: "0px !important"
//     },
//     visuallyHidden: {
//         border: 0,
//         clip: 'rect(0 0 0 0)',
//         height: 1,
//         margin: -1,
//         overflow: 'hidden',
//         padding: 0,
//         position: 'absolute',
//         top: 20,
//         width: 1,
//       }
// }));

const styles = theme => ({
    header: {
        backgroundColor: theme.palette.nav.app,
        [theme.breakpoints.up('sm')]: {
            paddingRight: 104,
            paddingLeft: 104
        },
        [theme.breakpoints.down('sm')]: {
            paddingRight: 48,
            paddingLeft: 48
        },
    },
    headerText: {
        color: '#000',
        fontSize: 28,
        marginTop: 10,
        marginBottom: 10
    }
});
class CurrentAccount extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            rows: [],
            saldoPending: null,
            xlsxData: []
        }
    }
    componentDidMount() {
        this.getCCA()
        this.getSaldoPendig()
        
    }
    createData = (code, date, dueDate, cuenta, amount, pending, overdue, status, data, id, k2) => {
        return { code, date, dueDate, cuenta, amount, pending, overdue, status, data, id, k2};
    }

    generateExel = (rows) => {
        
        const csvData = [
            [
                "COMPROBANTE",
                "FECHA",
                "VENCIMIENTO",
                "C/G",
                "ATRASO",
                "IMPORTE",
                "SALDO"
            ],
        ];

        rows.forEach((row, index) => {
            csvData.push([
                row.code,
                row.date,
                row.dueDate,
                row.cuenta,
                row.overdue,
                row.amount,
                row.pending
            ]);
        });

        this.setState({xlsxData: csvData})
        
    }

    getCCA = async (x) => {
        if (!x) {
            x = {
                start: new Date(1295300399099).setHours(0, 0, 0, 0), end: new Date().setHours(23, 59, 59, 99)
            }
        }
        if (localStorage.historialCobranzas.length > 0) {
            this.setState({ rows: JSON.parse(localStorage.historialCobranzas) })

        }
        else {

            let first = "rawQueries=c='" + localStorage.client + "' AND "
            let second = "tc>" + x.start + " AND tc<" + x.end
            let third = " AND deletedAt is null"
            let fourth = " ORDER BY te DESC"

            let ccaQuery = first + second + third + fourth
            
            const cuentaCorriente = await getFromAPI(
                "CurrentAccount",
                ccaQuery,
                120000,
                true
            )


            const rowres = []
            const a2 = moment()
            for (let element of cuentaCorriente) {
                const a1 = moment(element.te)
                const diff = a2.diff(a1, 'days')

                let montoOriginal = 0
                let saldo = 0
                if (element.q) {
                    for (let cuota of Object.values(element.q)) {
                        montoOriginal = +cuota.ia
                        saldo = +cuota.ia - +cuota.pa
                    }
                }

                rowres.push(
                    this.createData(
                        (element.dc + "-" + element.do + "-" + element.dn),
                        moment(element.tc).format('DD/MM/YYYY'),
                        moment(element.te).format('DD/MM/YYYY'),
                        element.cuenta, 
                        '$ ' + montoOriginal,
                        '$ ' + saldo,
                        (diff < 0 ? 0 : diff),
                        element.s === 1 ? ('En Proceso') : ('Facturado'),
                        element,
                        element.id, 
                        element.k2
                    ))
            }

            this.setState({ rows: rowres })
            localStorage.historialCobranzas = JSON.stringify(rowres)
            
        }
    }

    getSaldoPendig = async (x) => {
        if (!x) {
            x = {
                start: new Date(1295300399099).setHours(0, 0, 0, 0), end: new Date().setHours(23, 59, 59, 99)
            }
        }
            let first = "rawQueries=c='" + localStorage.client + "' AND "
            let second = "tc>" + x.start + " AND tc<" + x.end
            let third = " AND deletedAt is null"
            let fourth = " ORDER BY te DESC"

            let ccaQuery = first + second + third + fourth
            
            const cuentaCorriente = await getFromAPI(
                "CurrentAccount",
                ccaQuery,
                120000,
                true
            )

            const a2 = moment()
            let sumSaldoVen = 0
            for (let element of cuentaCorriente) {
                const a1 = moment(element.te)
                let diff = a2.diff(a1, 'days')
                const saldoOver = (diff < 0 ? 0 : diff)

                let montoOriginal = 0
                let saldo = 0
                if (element.q) {
                    for (let cuota of Object.values(element.q)) {
                        montoOriginal = +cuota.ia
                        saldo = +cuota.ia - +cuota.pa
                    }
                }  
                
                if(saldoOver > 0){
                    if(saldo > 0) sumSaldoVen += saldo
                }       
            }

            this.setState({saldoPending: sumSaldoVen.toFixed(2)})
            localStorage.saldoVencido = `${sumSaldoVen.toFixed(2)}`
        
    }

    


    render() {

        const { classes } = this.props;
        let sumG = 0
        let sumC = 0
        for(let i in this.state.rows){
            let cta = this.state.rows[i]

            if(cta.cuenta == 'G' || cta.cuenta == 'G ' || cta.cuenta == ' G' || cta.cuenta == ' G '){
                sumG += Number((cta.pending.replace('$', '')).replace(',', ''))
            } 
            if(cta.cuenta == 'C' || cta.cuenta == 'C ' || cta.cuenta == ' C' || cta.cuenta == ' C '){
                sumC += Number((cta.pending.replace('$', '')).replace(',', ''))
            }
        }

        sumG = sumG.toFixed(2)
        sumC = sumC.toFixed(2)


        return (
            <div>
                <div className={classes.header} >

                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", height: 115 }}>
                        <div style={{ zIndex: 1 }}>
                            <p style={{ fontSize: 28, marginTop: 10, marginBottom: 10 }}>Cuenta Corriente</p>
                        </div>
                        <div style={{ zIndex: 1, display: "flex", alignItems: 'center', marginTop: 20, marginBottom: 0}}>
                            <div style={{ display: "flex" , flexDirection: 'column' }}>
                                <p style={{ fontSize: 18, marginTop: 0, marginBottom: 0}}> <b> Saldo total : </b>$ {parseFloat(localStorage.saldo).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</p>
                                <div style={{display: 'flex', marginTop: 0, marginBottom: 0}}>
                                    <p style={{ fontSize: 12, width: '50%'}} ><b>CIG: $ {sumC}</b></p>
                                    <p style={{ fontSize: 12, width: '50%'}} ><b>VA: $ {sumG}</b></p>
                                </div>
                            </div>
                            
                            { this.state.saldoPending ? <p style={{ fontSize: 14 , marginLeft: 20, color: '#f44336', marginTop: 0, marginBottom: 0 }}> <b> Vencido : </b>${ this.state.saldoPending} </p>: ''}
                        </div>
                    </div>

                </div>

                
                <Container style={{marginTop: 25, display: 'flex', justifyContent: 'flex-end'}}>
                    <CSVLink
                                data={this.state.xlsxData}
                                enclosingCharacter={''}
                                style={{
                                    textTransform: "none",
                                    color: "#454545",
                                    textDecoration: "none",
                                }}
                                filename={"CuentasCorrientesB2B.csv"}
                                target="_blank"
                                separator={";"}
                                asyncOnClick={true}
                                onClick={() => this.generateExel(this.state.rows)}
                            >
                                <Button
                                        variant="contained"
                                        style={{
                                        marginLeft: 15,
                                        marginRight: 0,
                                        paddingLeft: 16,
                                        paddingRight: 16,
                                        width: 128,
                                        height: 32
                                        }}
                                        // onClick={() => this.generateExel(this.state.rows)}
                                        className={"whitespace-no-wrap mr-5"}
                                        size="medium"
                                        // disabled = { selectionRowsChecked.length == 0}
                                    >
                                        <span className="sm:flex normal-case">Descargar</span>
                                        
                                    </Button>
                    </CSVLink>
                </Container>
                <Container maxWidth="lg" style={{ marginTop: 25 }}>
                    <CurrentAccountTable rowsprop={this.state.rows} props={this.props}> </CurrentAccountTable>
                </Container>
            </div>
        )
    }
}

const StyledTableRow = withStyles((theme: Theme) =>
    createStyles({
        root: {
            '&:nth-of-type(odd)': {
                backgroundColor: theme.palette.action.hover,
            }

        },
    }),
)(TableRow);

function CurrentAccountTable({rowsprop, props}) {
    const classes = useStyles();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    let rows = rowsprop;
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    
    const [order, setOrder] = React.useState("asc");
    const [orderBy, setOrderBy] = React.useState("k");
    const [saldoVencido, setSaldoVencido] = React.useState(null)

    rows = rows.sort((a, b) => moment(a.date, "DD/MM/YY").unix() - moment(b.date, "DD/MM/YY").unix())

    const handleRequestSort = (property) => {


        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    useEffect(()=>{
        handleRequestSort('date')
    }, [])

    useEffect(()=>{
        let sumSaldoVen = 0
        for(let i in rows){
            if(rows[i].overdue > 0){
                let saldoPending = Number((rows[i].pending.replace('$', '')).replace(',', ''))
                if(saldoPending > 0) sumSaldoVen += saldoPending
            }
        }
        localStorage.saldoVencido = `${sumSaldoVen.toFixed(2)}`
        setSaldoVencido(sumSaldoVen.toFixed(2))
    }, [rows])

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    function stableSort(array, comparator) {

        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) {
                return order;
            }
            return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
    }


    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }

    function descendingComparator(a, b, orderBy) {

        if(orderBy == 'date' || orderBy == 'dueDate'){
            if (moment(b[orderBy], "DD/MM/YY").unix() == moment(a[orderBy], "DD/MM/YY").unix()) {
                if(b['data'].rk < a['data'].rk) {
                    return -1;
                }
                if(b['data'].rk > a['data'].rk) {
                    return 1;
                }
                
                return 0
            }else{
                if (moment(b[orderBy], "DD/MM/YY").unix() < moment(a[orderBy], "DD/MM/YY").unix()) {
                    return -1;
                }
                if (moment(b[orderBy], "DD/MM/YY").unix() > moment(a[orderBy], "DD/MM/YY").unix()) {
                    return 1;
                }    
                return 0;         
            }     
        }else{
            if (b[orderBy] < a[orderBy]) {
                return -1;
            }
            if (b[orderBy] > a[orderBy]) {
                return 1;
            }
            return 0;
        }
    
    }


    return (
        <Paper className={classes.root}>
            <TableContainer className={classes.container}>
                <Table stickyHeader size="small" aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth }}
                                >
                                    {
                                        column.id != "download" ?
                                            <TableSortLabel
                                                active={orderBy === column.id}
                                                direction={orderBy === column.id ? order : 'asc'}
                                                onClick={() => {
                                                    handleRequestSort(column.id)
                                                }}
                                            >
                                                {column.label}
                                                {orderBy === column.id ? (
                                                    <span className={classes.visuallyHidden}>
                                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                                    </span>
                                                ) : null}
                                            </TableSortLabel> : column.label
                                    }


                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {stableSort(Object.values(rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)), getComparator(order, orderBy)).map((row, key) => {
                            if (
                                row.overdue > 0 && parseFloat(row.pending.replace('$', '')) > 0
                            ) {
                                return (
                                    <StyledTableRow style={{ backgroundColor: "#f44336" }} key={key.code} role="checkbox" tabIndex={-1} >
                                        {columns.map((column) => {
                                            const value = row[column.id];
                                            if (column.id === "download") {
                                                return <TableCell style={{ color: row.overdue > 0 && parseFloat(row.pending.replace('$', '')) > 0 ? '#fff' : '#222', fontWeigth: row.overdue > 0 ? '800' : '400' }} key={column.id} align={column.align}>
                                                    <IconButton disabled onClick={() => { window.open("https://kiri.mobi/storeApiSales/snLts1zpQu/" + row.k2 + ".PDF") }} aria-label="delete" size="small">
                                                        <GetAppRounded fontSize="inherit" />
                                                    </IconButton>
                                                </TableCell>
                                            }
                                            return (
                                                <TableCell style={{ color: row.overdue > 0 && parseFloat(row.pending.replace('$', '')) > 0 ? '#fff' : '#222', fontWeigth: row.overdue > 0 ? '800' : '400' }} key={column.id} align={column.align}>
                                                    {column.format && typeof value === 'number' ? column.format(value) : value}
                                                </TableCell>
                                            );
                                        })}
                                    </StyledTableRow>
                                );
                            }
                            return (
                                <StyledTableRow className={row.overdue > 0 && parseFloat(row.pending.replace('$', '')) > 0 ? 'overdue' : 'normal'} key={key.code} role="checkbox" tabIndex={-1} >
                                    {columns.map((column) => {
                                        const value = row[column.id];
                                        if (column.id === "download") {
                                            return <TableCell style={{ color: row.overdue > 0 && parseFloat(row.pending.replace('$', '')) > 0 ? '#fff' : '#222', fontWeigth: row.overdue > 0 ? '800' : '400' }} key={column.id} align={column.align}>
                                                <IconButton disabled onClick={() => { window.open("https://kiri.mobi/storeApiSales/snLts1zpQu/" + row.k2 + ".PDF") }} aria-label="delete" size="small">
                                                    <GetAppRounded fontSize="inherit" />
                                                </IconButton>
                                            </TableCell>
                                        }
                                        return (
                                            <TableCell style={{ color: row.overdue > 0 && parseFloat(row.pending.replace('$', '')) > 0 ? '#fff' : '#222', fontWeigth: row.overdue > 0 ? '800' : '400' }} key={column.id} align={column.align}>
                                                {column.format && typeof value === 'number' ? column.format(value) : value}
                                            </TableCell>
                                        );
                                    })}
                                </StyledTableRow>
                            );
                        })}

                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                labelRowsPerPage="Filas por página"
                labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
            />
        </Paper>
    );
}

export default withStyles(styles)(CurrentAccount);
